module.exports = __webpack_public_path__ + "img/yl3077.6566f5c4.png";